export default __webpack_public_path__ + "static/media/AsistenciaAlumnos.859e65e0.svg";